export default __webpack_public_path__ + "static/media/notification_alt.1a127aec.mp3";